<template>
  <v-container
    :style="this.$vuetify.breakpoint.smAndDown ? '' : 'width: 870px;'"
  >
    <div id="history">
      <HistorySearch />
    </div>
  </v-container>
</template>

<script>
import HistorySearch from "@/components/HistorySearch.vue";
export default {
  name: "History",

  components: {
    HistorySearch
  }
};
</script>
